<template>
  <div class="fliter-wrapper">
    <!--    add class ob-->
    <div class="filter">
      <div class="fliter-content" v-bind:class="{filter_h_expend: isToggleFilter}" id="filter-t1">
        <div class="title d-flex">
          <div>{{$t('cFilter.filter')}}</div>

          <span
            v-if="filterWatchList.star.some(star => star.by === 'user')"
            @click="clearAllFilter(filterWatchList)"
          >{{$t('cFilter.clearAll')}}</span>
        </div>
<!-- :currencyCode="GET_CURRENCY.code" -->
        <cFilterTag
          
          @clearSelFilter="clearSelFilter"
          :dispFilterLs="dispFilterLs"
          @toToggleFilter="toggleFilter"
        ></cFilterTag>
      </div>

      <div class="fcontent-wrap pb-15px">
        <div class="sub-title">
          <div>{{$t('hotelResults.filter.star')}}</div>
          <span
            v-if="filterWatchList.star.by === 'user'"
            @click="clearFilter('star',filterWatchList)"
          >{{$t('cFilter.clear')}}</span>
        </div>
        <div class="filter-item">
          <div class="content">
            <cFilterStar
                      v-on:input="triggerCFilterFn"
                      :filterWatList="filterWatchList"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BaseConfiguration from "../../../../config/base.js";

import cFilterStar from "../../../../components/booking/hotel/result/cFilterStar";

import Logger from "../../../../services/logger";
import { mapGetters, mapActions } from "vuex";
import {
  LOG_TYPE,
  FILE_NAME,
  HTTP_CODES,
  API_VALUES
} from "../../../../config/API_DATA";
import cFilterTag from "../../../../components/booking/hotel/result/cFilterTag";
import { COMPONENT_NAME, FILTER, PATHNAME } from "../../../../util/constants";
import { cloneData } from "../../../../util/util";
export default {
  name: COMPONENT_NAME.C_ALL_FILTER_HOTEL,
  components: {
    cFilterStar,
    cFilterTag
  },
  props: {
    filterWatList: {
      type: Object
    },
    isStopsForNonMyanmar: {
      type: Boolean
    },
    selObFilterItems: {
      type: Object
    }
  },
  data: () => ({
    // flightResponse: [] | {},
    filterWatchList: {},
    isToggleFilter: false,
    dispFilterLs: []
  }),
  watch: {
    // selObFilterItems:function(){
    //     this.clearSelFilter(this.selObFilterItems);
    //   },
    filterWatList: {
      immediate: false,
      deep: true,
      handler: function(newVal, oldVal) {
        this.filterWatchList = this.filterWatList;
      }
    }
  },
  computed: {
    ...mapGetters("sHotelResult", {
      GET_DISP_FILTER_LS: "GET_DISP_FILTER_LS",
      GET_CURRENCY: "GET_CURRENCY"
    })
  },

  methods: {
    ...mapActions("sHotelResult", {
      SET_DISP_FILTER_LS: "SET_DISP_FILTER_LS"
    }),

    ////only to display the applied filter in filter tag in ui
    toDispFilterTagLs(pFilterKey, pFilterObj) {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("toDispFilterTagLs");
     
      
        ///stops
        if (pFilterKey == "star") {
          let starLs = [];
          pFilterObj.star.filter(starObj => {
            if (starObj.status === 1 && starObj.by === "user") {
              starLs.push(starObj);
              this.dispFilterLs.push(starObj);
            }
          });

          let starfilter = [];
          starfilter = this.dispFilterLs.filter(function(objFromA) {
            return !pFilterObj.star.find(function(objFromB) {
              return objFromA.code === objFromB.code;
            });
          });
          // if(starLs.length!=0 && starLs[0].name!='All Stops'){
          // starfilter.push(starLs[0]);
          // }

          this.dispFilterLs = starfilter;
        }
       

       
        
        this.SET_DISP_FILTER_LS(this.dispFilterLs);
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.C_ALL_FILTER_HOTEL,
          "error in toDispFilterTagLs",
          err.toString(),
          "toDispFilterTagLs",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },
    toggleFilter(pToggleFilter) {
      try {
        if (BaseConfiguration.isDebug) console.log("isToggleFilter");

        this.isToggleFilter = pToggleFilter;
      } catch (err) {
        let body = Logger.buildRequest(
          PATHNAME.FLIGHTRESULTS,
          "error while modifing search",
          err.toString(),
          "isToggleFilter",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
    clearSelFilter(pFilterName) {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("clearSelFilter");
        // if (pFilterName.min) {
        //   retValue = "price";
        //   this.clearFilter(retValue, this.filterWatchList);
        // } else if (pFilterName.from) {
        //   retValue = "totalDuration";
        //   this.clearFilter(retValue, this.filterWatchList);
        // } else if (
        //   !this.isStopsForNonMyanmar &&
        //   this.filterWatchList.via.some(via => via.name === pFilterName.name)
        // ) {
        //   this.clearFilter("via", this.filterWatchList);
        // } else
         if (
          this.isStopsForNonMyanmar &&
          this.filterWatchList.stops.some(
            stops => stops.name === pFilterName.name
          )
        ) {
          this.clearFilter("stops", this.filterWatchList);
        }
        //  else if (
        //   this.filterWatchList.al.some(al => al.name === pFilterName.name)
        // ) {
        //   this.filterWatchList.al.filter(alObj => {
        //     if (alObj.name === pFilterName.name) {
        //       alObj.status = 0;
        //       alObj.by = "default";
        //     } else {
        //       alObj.status = 1;
        //     }
        //   });
        //   this.toDispFilterTagLs("al", this.filterWatchList);

        //   this.$emit("cAllFilterHotelFn", this.filterWatchList);
        //   // this.$emit(
        //   //  "getFilterTag",
        //   //  this.dispFilterLs
        //   // );
        // } else if (
        //   this.filterWatchList.depTime.some(
        //     depTime => depTime.start === pFilterName.start
        //   )
        // ) {
        //   this.filterWatchList.depTime.filter(depTimeObj => {
        //     if (depTimeObj.start === pFilterName.start) {
        //       depTimeObj.status = 0;
        //       depTimeObj.by = "default";
        //     } else {
        //       depTimeObj.status = 1;
        //     }
        //   });
        //   this.toDispFilterTagLs("depTime", this.filterWatchList);

        //   this.$emit("cAllFilterHotelFn", this.filterWatchList);
        //   // this.$emit(
        //   //  "getFilterTag",
        //   //  this.dispFilterLs
        //   // );
        // }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.C_ALL_FILTER_HOTEL,
          "error in clearSelFilter",
          err.toString(),
          "clearSelFilter",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      // return retValue;
    },

    triggerCFilterFn(pSelFilterVal, pFilComp) {
      try {
        if (BaseConfiguration.isDebug) console.log("triggerCFilterFn");

        let retFilWatchList;
        // let alFiler = [];
        // if (pFilComp == FILTER.C_FILTER_AL) {
        //   retFilWatchList = this.updateFilWatchList(
        //     pSelFilterVal,
        //     this.filterWatchList,
        //     pFilComp
        //   );
        //   if (retFilWatchList) {
        //     this.filterWatchList = retFilWatchList;
        //     this.toDispFilterTagLs("al", this.filterWatchList);
        //   }
        // } else if (pFilComp == FILTER.C_FILTER_PRICE) {
        //   retFilWatchList = this.updateFilWatchList(
        //     pSelFilterVal,
        //     this.filterWatchList,
        //     pFilComp
        //   );
        //   if (retFilWatchList) {
        //     this.filterWatchList = retFilWatchList;
        //     this.toDispFilterTagLs("price", this.filterWatchList);
        //   }
        // } else 
        if (pFilComp == FILTER.C_FILTER_STAR) {
          retFilWatchList = this.updateFilWatchList(
            pSelFilterVal,
            this.filterWatchList,
            pFilComp
          );
          if (retFilWatchList) {
            this.filterWatchList = retFilWatchList;
            this.toDispFilterTagLs("star", this.filterWatchList);
          }
        }
        //  else if (pFilComp == FILTER.C_FILTER_VIA) {
        //   retFilWatchList = this.updateFilWatchList(
        //     pSelFilterVal,
        //     this.filterWatchList,
        //     pFilComp
        //   );
        //   if (retFilWatchList) {
        //     this.filterWatchList = retFilWatchList;
        //     this.toDispFilterTagLs("via", this.filterWatchList);
        //   }
        // } else if (pFilComp == FILTER.C_FILTER_DUR) {
        //   retFilWatchList = this.updateFilWatchList(
        //     pSelFilterVal,
        //     this.filterWatchList,
        //     pFilComp
        //   );
        //   if (retFilWatchList) {
        //     this.filterWatchList = retFilWatchList;
        //     this.toDispFilterTagLs("totalDuration", this.filterWatchList);
        //   }
        // } else if (pFilComp == FILTER.C_FILTER_DEPTIME) {
        //   retFilWatchList = this.updateFilWatchList(
        //     pSelFilterVal,
        //     this.filterWatchList,
        //     pFilComp
        //   );
        //   if (retFilWatchList) {
        //     this.filterWatchList = retFilWatchList;
        //     this.toDispFilterTagLs("depTime", this.filterWatchList);
        //   }
        // }
        // this.dispFilterLs=this.toDispFilterTagLs(this.filterWatchList);

        this.$emit("cAllFilterHotelFn", this.filterWatchList);
        // this.$emit(
        //  "getFilterTag",
        //  this.dispFilterLs
        // );
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_ALL_FILTER,
          "error in triggerCFilterFn",
          err.toString(),
          "triggerCFilterFn",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    updateFilWatchList(pFilterValue, pfilterWatchList, pFilterComp) {
      try {
        if (BaseConfiguration.isDebug) console.log("updateFilWatchList");
        let retFilterWatchls = {};

        if (pfilterWatchList) {
          retFilterWatchls = pfilterWatchList;
        }
        retFilterWatchls[pFilterComp] = pFilterValue;
        return retFilterWatchls;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_ALL_FILTER,
          "error in updateFilWatchList",
          err.toString(),
          "updateFilWatchList",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    clearAllFilter(pFilterObj) {
      // let filterObj;
      try {
        if (BaseConfiguration.isDebug) console.log("clearAllFilter");
        //  filterObj=this.GET_OB_FILTER_DATA;
        for (var i in pFilterObj) {
          if (pFilterObj[i].length && pFilterObj[i].length != 0) {
            for (let j = 0; j < pFilterObj[i].length; j++) {
            //   if (i == FILTER.C_FILTER_AL) {
            //     pFilterObj[i][j].status = 0;
            //     pFilterObj[i][j].by = "default";
            //     this.toDispFilterTagLs(i, this.filterWatchList);
            //   } else if (i == FILTER.C_FILTER_DEPTIME) {
            //     pFilterObj[i][j].status = 0;
            //     pFilterObj[i][j].by = "default";
            //     this.toDispFilterTagLs(i, this.filterWatchList);
            //   } else if (i == FILTER.C_FILTER_VIA) {
            //     if (j == 0) {
            //       pFilterObj[i][j].status = 1;
            //     } else {
            //       pFilterObj[i][j].status = 0;
            //     }
            //     pFilterObj[i][j].by = "default";
            //   } else
               if (i == FILTER.C_FILTER_STAR) {
                if (j == 0) {
                  pFilterObj[i][j].status = 1;
                } else {
                  pFilterObj[i][j].status = 0;
                }
                pFilterObj[i][j].by = "default";
              }
            }
            this.toDispFilterTagLs(i, this.filterWatchList);
          } 
          // else {
          //   if (i == FILTER.C_FILTER_PRICE) {
          //     pFilterObj[i].from = pFilterObj[i].min;
          //     pFilterObj[i].to = pFilterObj[i].max;
          //     pFilterObj[i].by = "default";
          //     this.toDispFilterTagLs(i, this.filterWatchList);
          //   } else if (i == FILTER.C_FILTER_DUR) {
          //     // if(pFilterObj[i].start==pFilterObj[i].end){
          //     //   pFilterObj[i].from=0;
          //     // pFilterObj[i].to=pFilterObj[i].end;
          //     // pFilterObj[i].by='default';
          //     // this.toDispFilterTagLs(i,this.filterWatchList);
          //     // }else{
          //     pFilterObj[i].from = pFilterObj[i].start;
          //     pFilterObj[i].to = pFilterObj[i].end;
          //     pFilterObj[i].by = "default";
          //     this.toDispFilterTagLs(i, this.filterWatchList);
          //     // }
          //   }
          // }
        }
        this.$emit("cAllFilterHotelFn", pFilterObj);
        this.isToggleFilter = false;
        // this.$emit(
        //  "getFilterTag",
        //  this.dispFilterLs
        // );
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.C_ALL_FILTER_HOTEL,
          "error in clearAllFilter",
          err.toString(),
          "clearAllFilter",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    clearFilter(pFilter, pFilterObj) {
      // let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("clearFilter");

        if (pFilterObj[pFilter].length && pFilterObj[pFilter].length != 0) {
          for (let j = 0; j < pFilterObj[pFilter].length; j++) {
            // if (pFilter == FILTER.C_FILTER_AL) {
            //   pFilterObj[pFilter][j].status = 0;
            //   pFilterObj[pFilter][j].by = "default";
            //   this.toDispFilterTagLs(pFilter, this.filterWatchList);
            // } else if (pFilter == FILTER.C_FILTER_DEPTIME) {
            //   pFilterObj[pFilter][j].status = 0;
            //   pFilterObj[pFilter][j].by = "default";
            //   this.toDispFilterTagLs(pFilter, this.filterWatchList);
            // } else if (pFilter == FILTER.C_FILTER_VIA) {
            //   if (j == 0) {
            //     pFilterObj[pFilter][j].status = 1;
            //   } else {
            //     pFilterObj[pFilter][j].status = 0;
            //   }
            //   pFilterObj[pFilter][j].by = "default";
            // } else 
            if (pFilter == FILTER.C_FILTER_STOPS) {
              if (j == 0) {
                pFilterObj[pFilter][j].status = 1;
              } else {
                pFilterObj[pFilter][j].status = 0;
              }
              pFilterObj[pFilter][j].by = "default";
            }
          }
          this.toDispFilterTagLs(pFilter, this.filterWatchList);
        } else {
          if (pFilter == FILTER.C_FILTER_PRICE) {
            pFilterObj[pFilter].from = pFilterObj[pFilter].min;
            pFilterObj[pFilter].to = pFilterObj[pFilter].max;
            pFilterObj[pFilter].by = "default";
            this.toDispFilterTagLs(pFilter, this.filterWatchList);
          } else if (pFilter == FILTER.C_FILTER_DUR) {
            if (pFilterObj[pFilter].start == pFilterObj[pFilter].end) {
              pFilterObj[pFilter].from = 2;
              pFilterObj[pFilter].to = pFilterObj[pFilter].to;
              pFilterObj[pFilter].by = "default";
              this.toDispFilterTagLs(pFilter, this.filterWatchList);
            } else {
              //    pFilterObj[pFilter].start=pFilterObj[pFilter].from;
              // pFilterObj[pFilter].end=pFilterObj[pFilter].to;
              pFilterObj[pFilter].from = pFilterObj[pFilter].start;
              pFilterObj[pFilter].to = pFilterObj[pFilter].end;
              pFilterObj[pFilter].by = "default";
              this.toDispFilterTagLs(pFilter, this.filterWatchList);
            }
          }
        }

        this.$emit("cAllFilterHotelFn", pFilterObj);
        // this.$emit(
        //  "getFilterTag",
        //  this.dispFilterLs
        // );
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.C_ALL_FILTER_HOTEL,
          "error in clearFilter",
          err.toString(),
          "clearFilter",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      // return retValue;
    }
  },
  created() {
    try {
      if (BaseConfiguration.isDebug) console.log("created");
      // console.log(this.flightRes);
      this.filterWatchList = this.filterWatList;
      if (
        this.GET_DISP_FILTER_LS &&
        this.GET_DISP_FILTER_LS.length != 0
      ) {
        this.dispFilterLs = this.GET_DISP_FILTER_LS;
      }
      // this.dispFilterLs = this.toDispFilterTagLs(this.filterWatchList);
      // this.flightResponse = this.flightRes;
      // if(!this.isUpdateWatCalled)
      // {
      // let retFilteredObValues = this.updateFilteredValues(
      //   this.filterWatchList,
      //   this.flightResponse
      // );
      // if (retFilteredObValues) {
      //   this.filterWatchList = retFilteredObValues;
      // }
      // }
    } catch (err) {
      let body = Logger.buildRequest(
        COMPONENT_NAME.C_ALL_FILTER,
        "error in created",
        err.toString(),
        "created",
        LOG_TYPE.ERROR
      );
      Logger.getResponse(body);
    }
  }
};
</script>
<style>
.badge-color {
  background-color: #d3d3d359;
  color: black;
}
</style>
